import React, { Component } from "react";
import { withTranslation } from 'react-i18next';
import styled from "styled-components";
import Modal from "./Modal";
import PlusImage from '../images/plus.svg'

const GenericDialogContainer = styled(Modal).attrs({
  underlayColor: 'rgba(255, 255, 255, 0.75)',
  underlayClass: "change-overlay",
  verticallyCenter: true,
  focusDialog: true
})`
`

const GenericModelContainer = styled.div`

  background-color: #FFFFFF;
  border: 1px solid rgb(204, 204, 204);
  border-radius: 2px;

  > div {
    display: flex;
    flex-direction: column;

    > header {
        flex-grow: 1;
        flex-shrink: 0;
    }

    > section {
        flex-shrink: 0;
    }

    > footer {
        flex-shrink: 0;
    }
  }

  // Desktop version.
  @media (min-width: 768px) {
    width: ${props => props.width ? props.width : 500 }px;
    height: ${props => props.height ? ""+props.height +"px" : "auto" };
  }

  // Mobile version.
  @media (max-width: 768px) {
    width: 100%;
    height: 100%;
  }

  div.generic-modal-header {
    border-bottom: 1px solid #CCCCCC;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    flex-direction: row;

    // Desktop version.
    @media (min-width: 768px) {
      padding: 15px 20px 16px 20px;
    }

    // Mobile version.
    @media (max-width: 768px) {
      padding: 15px 15px 16px 15px;
    }

    > h2 {
      font-family: Lato-Light;
      font-size: 18px;
      line-height: 22px;
      font-weight: normal;

      color: #4D4D4D;
      margin: 0px;
    }

    > button {
      background: url('${PlusImage}') no-repeat;
      border: 0;
      padding: 0px;
      width: 14px;
      height: 14px;
      cursor: pointer;
      margin-top: 4px;
    }
  }

  footer.generic-modal-footer {
    // Desktop version.
    @media (min-width: 768px) {
      padding: 15px 20px 20px 20px;
    }

    // Mobile version.
    @media (max-width: 768px) {
      padding: 15px 15px 20px 15px;
    }
  }

  section.generic-modal-content {
    // Desktop version.
    @media (min-width: 768px) {
      padding: 0;
      height: ${props => props.height ? "" + props.height + "px" : "auto" };
    }
  }

  footer {
    background-color: #EDEDED;
    border-top: 1px solid #CCCCCC;

    // Desktop version.
    @media (min-width: 768px) {
      ${props => props.height ? "vertical-align: bottom; left: 0px; right: 0px; bottom: 0px;" : ""};
    }
  }
`

class GenericModal extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    const { t } = this.props;
    const modalHeight = this.props.height
    const footerHeight = 77
    const headerHeight = 54
    const containerClassName = this.props.className || "generic-modal-container"
    const headerClassName = this.props.headerClassName || "generic-modal-header"
    const contentClassName = this.props.contentClassName || "generic-modal-content"
    const footerClassName = this.props.footerClassName || "generic-modal-footer"
    const hasContent = !(this.props.children === undefined)
    const hasFooter = Array.isArray(this.props.children) && this.props.children.length > 1

    var contentHeight = modalHeight - headerHeight
    let content = null
    if (hasContent) {
      content = Array.isArray(this.props.children) ? this.props.children[0] : this.props.children
    }
    let footer = null
    if (hasFooter) {
      footer = this.props.children[1]
      contentHeight = contentHeight - footerHeight
    }

    if(!this.props.visible){
      return null
    }

    return (
      <GenericDialogContainer titleText={this.props.title} underlayClickExits={false} onExit={this.props.onCloseDialog}>
        <GenericModelContainer
          width={this.props.width}
          height={this.props.height}
          className={containerClassName}
          autoSize={this.props.autoSize}
        >
          <div className={headerClassName}>
            <h2 tabIndex={0}>
              {this.props.title}
            </h2>
            {!this.props.hideCloseButton &&
              <button type="button" onClick={this.props.onCloseDialog} className='close-dialog' title={t('GenericDialog.CloseButton')}/>
            }
          </div>
          {hasContent && modalHeight &&
            <section style={{display:"flex", height: contentHeight}} className={contentClassName}>
              {content}
            </section>
          }
          {hasContent && !modalHeight &&
            <section className={contentClassName}>
              {content}
            </section>
          }
          {hasFooter &&
            <footer className={footerClassName}>
              {footer}
            </footer>
          }

        </GenericModelContainer>
      </GenericDialogContainer>
    );
  }
}

export default withTranslation('translations')(GenericModal);
